module.exports = __webpack_public_path__ + "img/pic_3.6eaaf9e0.png";